import React from 'react';
import { whyChoose, images, companyInfo } from '../data/mock';
import { Sparkles, ShieldCheck, Headphones, Settings, CheckCircle2 } from 'lucide-react';

const iconMap = {
  Sparkles: Sparkles,
  ShieldCheck: ShieldCheck,
  HeadphonesIcon: Headphones,
  Settings: Settings
};

const AboutSection = () => {
  const benefits = [
    "Reduce administrative workload by 60%",
    "Real-time insights and analytics",
    "Seamless parent-teacher communication",
    "Cloud-based, accessible anywhere"
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src={images.campus}
                alt="School Campus"
                className="rounded-3xl shadow-2xl w-full h-[500px] object-cover"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-4 -left-4 w-full h-full bg-gradient-to-br from-teal-500 to-cyan-500 rounded-3xl -z-10" />
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-teal-100 rounded-full -z-20" />
            
            {/* Floating Card */}
            <div className="absolute -bottom-8 -right-4 bg-white rounded-2xl shadow-xl p-6 z-20">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                  <CheckCircle2 className="w-6 h-6 text-teal-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-800">10+ Years</p>
                  <p className="text-slate-500 text-sm">Industry Experience</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="inline-block text-teal-600 font-semibold text-sm tracking-wider uppercase mb-4">
              About EdKonect
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-6 leading-tight">
              Transforming School Management Across India
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              EdKonect is a comprehensive campus management solution designed specifically for Indian schools. We understand the unique challenges faced by educational institutions and have crafted a platform that simplifies administration while enhancing the learning experience.
            </p>

            {/* Benefits List */}
            <div className="space-y-4 mb-10">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                    <CheckCircle2 className="w-4 h-4 text-teal-600" />
                  </div>
                  <span className="text-slate-700">{benefit}</span>
                </div>
              ))}
            </div>

            {/* Why Choose Grid */}
            <div className="grid grid-cols-2 gap-4">
              {whyChoose.map((item) => {
                const IconComponent = iconMap[item.icon];
                return (
                  <div
                    key={item.id}
                    className="bg-slate-50 rounded-xl p-4 hover:bg-teal-50 transition-colors group"
                  >
                    <div className="flex items-center gap-3">
                      {IconComponent && (
                        <IconComponent className="w-5 h-5 text-teal-600" />
                      )}
                      <span className="font-semibold text-slate-800 text-sm">
                        {item.title}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
